var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMigration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21h-2v-2.59L15.41 21 14 19.59 16.59 17H14v-2h6v6ZM5.5 12C2 12 0 12.7 0 14v8c0 1.3 2.83 2 5.5 2s5.5-.7 5.5-2v-8c0-1.3-2-2-5.5-2Zm0 1c2.485 0 4.5.672 4.5 1.5S7.985 16 5.5 16 1 15.328 1 14.5 3.015 13 5.5 13ZM1 20.238v-1.056c1.426.586 2.96.865 4.5.818 1.54.047 3.074-.232 4.5-.818v1.089c-1.436.542-2.966.79-4.5.729a11.64 11.64 0 0 1-4.5-.762ZM18.5 0C15 0 13 .7 13 2v8c0 1.3 2.83 2 5.5 2s5.5-.7 5.5-2V2c0-1.3-2-2-5.5-2Zm0 1c2.485 0 4.5.672 4.5 1.5S20.985 4 18.5 4 14 3.328 14 2.5 16.015 1 18.5 1ZM14 8.238V7.182c1.426.586 2.96.865 4.5.818 1.54.047 3.074-.232 4.5-.818v1.089c-1.436.542-2.966.79-4.5.729a11.64 11.64 0 0 1-4.5-.762Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigration);
export default __webpack_public_path__ + "static/media/migration.0f3b3105cc1d25599c9eeeb9f467bff9.svg";
export { ForwardRef as ReactComponent };